<template>
	<div class="longTask">
		<w-card hoverable class="long-task-card"  @touchend.prevent="openTaskDetail('click')" @click.stop="openTaskDetail('click')">
			<div
				:style="{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
          width: '100%',
				}"
			>
				<div class="card-content">
					<SvgIcon  :name="getIconName()" v-if="attrData.card" size="50" style="margin-right: 10px;" />

					<!-- <CoolAIchangwen v-if="attrData.card" size="50" style="margin-right: 10px;"/> -->
					<div style="width: calc(100% - 70px)">
						<w-typography-title class="truncate ... title-name" :heading="6" ><span v-html="attrData['task-name']"></span></w-typography-title>
            <w-typography-text style="color:#646479">{{source}}</w-typography-text>
					</div>
				</div>
			</div>
		</w-card>
	</div>
</template>
 
<script setup lang="ts">
import { useChatStore } from '/@/stores/chat';
import { ref, onMounted, toRefs, computed, nextTick, watch, defineAsyncComponent, onBeforeUnmount, onUnmounted } from 'vue';
import { Message } from 'winbox-ui-next';
import { dialogueTaskDateil,dialogueGuestTaskDateil,shareDialogueTaskDeatil } from '/@common/api/index';
import { useRoute } from 'vue-router';
import { getTicketId } from '/@common/utils/utils';
import DSBridge from '/@common/utils/dsBridge/dsBridge';
import { scrollBottom } from '/@common/utils/other';
import mittBus from '/@common/utils/mitt';
import { appHeight } from '/@common/utils/h5/adapter';
const LoadingStaus=ref(['RUNNING','PENDING'])
const route = useRoute();
const chatStore = useChatStore();
const taskId = ref('');
const taskData = ref({})
let timer: NodeJS.Timeout | null = null;

const props = defineProps<{
	attrData: {}; //子组件接收
  loading: boolean; //子组件接收
  dialogueId: string;
  from?: string;
  source?:string
}>();
//解构赋值
const { attrData,loading,dialogueId } = toRefs(props);
const getIconName=()=>{
	return localStorage.getItem('winbox-theme')?'cool-aIchangwen-fo1mnkjd': 'cool-aIchangwen'
}
const fetchTaskDetail = async () => {
  try {
    let api=getTicketId()?dialogueGuestTaskDateil:dialogueTaskDateil
    if(props?.from=='share'){
      api=shareDialogueTaskDeatil
    }
    const res = await api(taskId.value);
    if (res.code == 200) {
      taskData.value = res.data;
      if (chatStore.longTextContent?.id === taskData.value.id) {
        chatStore.longTextContent = taskData.value
      }
      
      if (res.data.status === 'SUCCESS') {
        scrollBottom('.home-content','auto',0)
        clearInterval(timer!);
      }else if(LoadingStaus.value.includes(res?.data?.status)){
        scrollBottom('.home-content')
      }
    }
  } catch (error) {
    console.error('获取任务详情失败:', error);
  }
};

const openTaskDetail = async(type?:string) => {
  if (DSBridge.isDSBridgeEnvironment()) {  //调用原生的方法
    let result=await dialogueTaskDateil(taskId.value)
    if(result?.code!=200){
      Message.info(result?.msg)
      return
    }else{
      DSBridge.callNative('triggerLongTaskCard', {taskId:taskId.value})
      return 
    }
  
	}
  if(props?.from=='manageHistory'){
    Message.info({
      id:'longTaskInfo',
      content:'此页面暂不支持查看'
    })
    return
  }
  if(!type){
    openWriteDetail()
    return
  }
  let api=getTicketId()?dialogueGuestTaskDateil:dialogueTaskDateil
  if(props?.from=='share'){
      api=shareDialogueTaskDeatil
    }
  let res=await api(taskId.value)
  if(res?.code!=200){
    Message.info(res?.msg)
    chatStore.isShowLongText=false
  }else{
    openWriteDetail()
    if(LoadingStaus.value.includes(res?.data?.status)){//再次循环请求
        timer = setInterval(fetchTaskDetail, 5*1000); 
    }
  }
}
const openWriteDetail = () => {
    chatStore.isShowLongText = true
    chatStore.longTextContent = taskData.value
}
const clearTimer = () => {
  if (timer) {
    clearInterval(timer);
  }
}
//处理 重新生成两个都是生成中的时候
watch(()=>attrData.value["task-id"],(newVal)=>{
  taskId.value = newVal
  chatStore.longTextContent.id = taskId.value 
},{immediate:true})
//处理同一个对话，不再走mounted时候
watch(()=>route.params.dialogueId,(newVal,oldVal)=>{
  if(dialogueId.value == newVal&&oldVal){
    clearTimer()
    taskId.value = attrData.value["task-id"]
    // openTaskDetail()
    chatStore.longTextContent = {id:taskId.value }
    fetchTaskDetail(); // 先触发一次请求
    timer = setInterval(fetchTaskDetail, 5*1000); 
  }
},{immediate:true})
onMounted(() => {
  mittBus.on('closeTaskView', () => {
    clearTimer()
  })
  clearTimer()
  taskId.value = attrData.value["task-id"]

  // 加载完成后自动触发
  if (loading.value) { 
    openTaskDetail()
    chatStore.longTextContent = {id:taskId.value }
  }

  // 监听路由变化自动触发
  if (dialogueId.value == route.params.dialogueId) {
    openTaskDetail()
    chatStore.longTextContent = {id:taskId.value }
  }
  fetchTaskDetail(); // 先触发一次请求
  timer = setInterval(fetchTaskDetail, 5*1000); // 每5秒调用一次
});

// 在组件卸载前清除定时器
onUnmounted(() => {
  if (timer) {
    clearInterval(timer);
  }
});

</script>

  
<style scoped lang="scss">
.longTask {
  .long-task-card{
    border-radius: 8px 8px 8px 8px;
    padding: 8px;
    cursor: pointer;
    width:100%;
    height: 76px;
    max-width: 450px;
    :deep(.w-card-body){
      padding: 0;
      // height: 60px;
      height: 100% !important;
      display: flex;
      align-items: center;
      width: 100%;
    }
    .card-content{
      width: 100%;
      display: flex;
      align-items: center;
    }
    h6.w-typography{
      width: 100%;
      margin-top: 0;
      margin-bottom: 4px;
      font-weight: 600;
      font-size: 18px;
      span{
        width: 100% !important;
        overflow: hidden;
      }
    }
  }
	// border: 1px solid #e4e8ee;
}
</style>
<style lang="scss">
</style>
